import { render, staticRenderFns } from "./TipoPessoa.vue?vue&type=template&id=287010a2"
import script from "./TipoPessoa.vue?vue&type=script&lang=js"
export * from "./TipoPessoa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports